import { render } from "./TheAdminVideoCategoryDestroy.vue?vue&type=template&id=c11ac75a&ts=true"
import script from "./TheAdminVideoCategoryDestroy.vue?vue&type=script&lang=ts"
export * from "./TheAdminVideoCategoryDestroy.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__